import i18n from '../i18n'

// Staging: REACT_APP_API_URL must be the Lets Roll API (e.g. https://staging-api-lets-roll.playlearning.io),
// not the web app. Same host for REACT_APP_API_WS_URL (wss://.../cable). REACT_APP_ADMIN_API_URL = admin app.
// If BASE_URL points at the web app, /users/exchange_token, /games/lobby and /user/game return HTML or 404.
const BASE_URL = process.env.REACT_APP_API_URL
const WS_URL = process.env.REACT_APP_API_WS_URL
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_ADMIN_URL
const REFRESH_TOKEN_URL = `${BASE_URL}/oauth/token`
const DEFAULT_PARAMS = { lang: i18n.language }

const Api = {
  BASE_URL,
  REFRESH_TOKEN_URL,
  DEFAULT_PARAMS,
  WS_URL,
  ADMIN_API_URL
}

export default Api
